<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('sportIndex.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="desc-box" v-if="type === 'pace'">
                <div class="desc-title">{{$t('sportIndex.pace')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.paceDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.avgPace')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.avgPaceDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.avgMovePace')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.avgMovePaceDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.bestPace')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.bestPaceDesc')}}<br>
                    {{$t('sportIndex.bestPaceDesc1')}}
                    <img class="best-icon" v-if="$i18n.locale === 'zh'" :src="require(`@/assets/theme/${theme}/sport/07sportIndex/01best.png`)">
                    <img class="best-icon" v-if="$i18n.locale === 'en'" :src="require(`@/assets/theme/${theme}/sport/07sportIndex/02best.png`)">
                    <img class="best-icon" v-if="$i18n.locale === 'ja'" :src="require(`@/assets/theme/${theme}/sport/07sportIndex/03best.png`)">
                </div>
            </div>
            <div class="desc-box" v-if="type === 'speed'">
                <div class="desc-title">{{$t('sportIndex.speed')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.speedDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.avgSpeed')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.avgSpeedDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.avgMoveSpeed')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.avgMoveSpeedDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.bestSpeed')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.bestSpeedDesc')}}<br>
                    {{$t('sportIndex.bestPaceDesc1')}}
                    <img class="best-icon" v-if="$i18n.locale === 'zh'" :src="require(`@/assets/theme/${theme}/sport/07sportIndex/01best.png`)">
                    <img class="best-icon" v-if="$i18n.locale === 'en'" :src="require(`@/assets/theme/${theme}/sport/07sportIndex/02best.png`)">
                    <img class="best-icon" v-if="$i18n.locale === 'ja'" :src="require(`@/assets/theme/${theme}/sport/07sportIndex/03best.png`)">
                </div>
            </div>
            <div class="desc-box" v-if="type === 'hrRange'">
                <div class="desc-title">{{$t('sportIndex.hrRange')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.hrRangeDesc')}} <br>
                    <span class="info-title">{{$t('sportIndex.hrRange0')}}</span> {{$t('sportIndex.hrRange0Desc')}}<br>
                    <span class="info-title">{{$t('sportIndex.hrRange1')}}</span> {{$t('sportIndex.hrRange1Desc')}}<br>
                    <span class="info-title">{{$t('sportIndex.hrRange2')}}</span> {{$t('sportIndex.hrRange2Desc')}}<br>
                    <span class="info-title">{{$t('sportIndex.hrRange3')}}</span> {{$t('sportIndex.hrRange3Desc')}}<br>
                    <span class="info-title">{{$t('sportIndex.hrRange4')}}</span> {{$t('sportIndex.hrRange4Desc')}}<br>
                </div>
            </div>
            <div class="desc-box" v-if="type === 'hrRecover'">
                <div class="desc-title">{{$t('sportIndex.hrRecover')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.hrRecoverDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'stride'">
                <div class="desc-title">{{$t('sportIndex.strideF')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.strideFDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.stride')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.strideDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'calories'">
                <div class="desc-title">{{$t('sportIndex.calories')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.caloriesDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.carbohydrate')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.carbohydrateDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.sweatLoss')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.sweatLossDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'power'">
                <div class="desc-title">{{$t('sportIndex.power')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.powerDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.avgPower')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.avgPowerDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.maxPower')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.maxPowerDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'trainingLoad'">
                <div class="desc-title">{{$t('sportIndex.trainingLoad')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.trainingLoadDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.effect')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.effectDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'vo2max'">
                <div class="desc-title">{{$t('sportIndex.vo2max')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.vo2maxDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'verSpeed'">
                <div class="desc-title">{{$t('sportIndex.verSpeed')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.verSpeedDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'rate'">
                <div class="desc-title">{{$t('sportIndex.rate')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.rateDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'trips'">
                <div class="desc-title">{{$t('sportIndex.trips')}}</div>
                <div class="desc-info">
                    {{$t('sportIndex.tripsDesc')}}
                </div>
                <div class="desc-title">{{$t('sportIndex.avgSwolf')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.avgSwolfDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'swimSpeed'">
                <div class="desc-title">{{$t('sportIndex.swimSpeed')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.swimSpeedDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'frequency'">
                <div class="desc-title">{{$t('sportIndex.frequency')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.frequencyDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'strokeRate'">
                <div class="desc-title">{{$t('sportIndex.strokeRate')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.strokeRateDesc')}}
                </div>
            </div>
            <div class="desc-box" v-if="type === 'fitness'">
                <div class="desc-title">{{$t('sportIndex.fitness')}}</div>
                <div class="desc-info last-desc">
                    {{$t('sportIndex.fitnessDesc')}}
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: '07sportIndex',
    data() {
        return {
            type: '',
            theme: ''
        }
    },
    mounted() {
        if (this.$route.query.type) {
            this.type = this.$route.query.type;
        }
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        }
    }
}
</script>

<style scoped>
.score-li {
    margin-left: 30px;
}

.info-title {
    font-weight: bold;
}

.best-icon {
    width: 308px;
    margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/sport/07sportIndex.vue